// ========================= LOAD CART =========================
function load_cart() {
  
  // Fetch Drawer HTML
  fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
    .then(res => res.text())
    .then(responseText => {
      const cartId = "cart-drawer";
      const html = new DOMParser().parseFromString(responseText, "text/html");

      const destination = document.querySelector(".cart-sidebar");
      const source = html.getElementById(cartId);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        console.log(destination.innerHTML);
      }

      // Init all functional blocks
      bindRemoveItemButtons();
      initCartDrawerVisibility();
      initDiscountToggle();
      bindHeaderCartClick();
      bindDrawerCloseClick();
      initCartSlidersByDevice();
      initCartmbUpsell();
      updateCartCount();
      cartVariant();

      // Bundle + Free product logic
      handleFreeThresholdProduct();
      handleBuyXGetY();
      handleBuyXGetY_Second();

      cartDrawerUpdate();
    });
}

// =============================================================
// Remove Item Buttons
// =============================================================
function bindRemoveItemButtons() {
  document.querySelectorAll(".item-remove").forEach(btn => {
    const line = btn.dataset.line;

    btn.addEventListener("click", () => {
      removeItem(line);

      setTimeout(() => {
        const upsellWrap = document.querySelector(".cart-upsell-wrap");
        if (upsellWrap) upsellWrap.style.opacity = "1";
      }, 2000);
    });
  });
}

// =============================================================
// Drawer Visibility (empty/middle/footer)
// =============================================================
function initCartDrawerVisibility() {
  const drawerMiddle = document.querySelector(".cart-sidebar .drawer-middle");
  const drawerFooter = document.querySelector(".cart-sidebar .drawer-footer");
  const emptyDiv = document.querySelector(".cart-sidebar .empty-cart");
  const cartItems = document.querySelectorAll(".cart-sidebar .cartitems");

  const hasItems = cartItems.length > 0;

  if (drawerMiddle) drawerMiddle.style.opacity = hasItems ? "1" : "0";
  if (drawerFooter) drawerFooter.style.opacity = hasItems ? "1" : "0";
  if (emptyDiv) emptyDiv.style.opacity = hasItems ? "0" : "1";
}

// =============================================================
// Discount Accordion Toggle
// =============================================================
function initDiscountToggle() {
  document.querySelectorAll(".cart-discount-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const parent = btn.closest(".dr-stack-cart");
      if (parent) parent.classList.toggle("active");
    });
  });
}

// =============================================================
// Header Cart Button Click
// =============================================================
function bindHeaderCartClick() {
  document.querySelectorAll(".header-cart").forEach(btn => {
    btn.addEventListener("click", () => {
      const body = document.body;
      const cartDrawer = document.querySelector(".cart-sidebar");
      const upsell = document.querySelector(".cart-upsell-wrap");
      const footer = document.querySelector(".cart-sidebar .drawer-footer");
      const middle = document.querySelector(".cart-sidebar .drawer-middle");

      body.classList.add("open-drawer");
      body.classList.remove("open-menu", "open-search", "open-sort", "open-filter");
      lenis.stop();

      initCartmbUpsell();
      initCartSlidersByDevice();

      if (!cartDrawer) return;

      if (window.innerWidth > 767) {
        cartDrawer.style.maxHeight = `${window.innerHeight}px`;
        cartDrawer.style.opacity = "1";

        cartDrawer.addEventListener("transitionend", function handler(ev) {
          if (ev.propertyName === "max-height") {
            if (upsell) upsell.style.opacity = "1";
            if (footer) footer.style.opacity = "1";
            if (middle) middle.style.opacity = "1";
            cartDrawer.removeEventListener("transitionend", handler);
          }
        });
      } else {
        if (upsell) upsell.style.opacity = "1";
      }
    });
  });
}

// =============================================================
// Drawer Close
// =============================================================
function bindDrawerCloseClick() {
  document.querySelectorAll(".overlay-box, .cart-drawer-close").forEach(btn => {
    btn.addEventListener("click", () => {
      const body = document.body;
      const cartDrawer = document.querySelector(".cart-sidebar");
      const upsell = document.querySelector(".cart-upsell-wrap");
      const footer = document.querySelector(".cart-sidebar .drawer-footer");
      const middle = document.querySelector(".cart-sidebar .drawer-middle");

      body.classList.remove("open-drawer", "open-menu", "open-search", "open-sort", "open-filter");

      if (upsell) upsell.style.opacity = "0";

      lenis.start();

      if (window.innerWidth > 767 && cartDrawer) {
        cartDrawer.style.maxHeight = "0px";
        cartDrawer.style.opacity = "0";
        if (footer) footer.style.opacity = "0";
        if (middle) middle.style.opacity = "0";

        cartDrawer.addEventListener("transitionend", function handler() {
          cartDrawer.style.maxHeight = "";
          cartDrawer.style.opacity = "";
          cartDrawer.removeEventListener("transitionend", handler);
        });
      }
    });
  });
}

// =============================================================
// Init Sliders (Desktop Only)
// =============================================================
function initCartSlidersByDevice() {
  if (window.innerWidth > 767) {
    initCartSliders();
  }
}

// =============================================================
// Update Cart Count
// =============================================================
function updateCartCount() {
  fetch("/cart.js")
    .then(resp => resp.json())
    .then(data => {
      document.querySelector(".cart-count").innerHTML = data.item_count;
    })
    .catch(err => console.log(err));
}

// =============================================================
// THRESHOLD FREE PRODUCT
// =============================================================
function handleFreeThresholdProduct() {
  const cartForm = document.querySelector("form[data-free-product]");
  if (!cartForm) return;

  const threshold = Number(cartForm.dataset.freeThreshold || 0);
  const freeProduct = Number(cartForm.dataset.freeProduct || 0);
  if (!freeProduct || !threshold) return;

  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const total = cart.items_subtotal_price / 100;
      const freeItem = cart.items.find(i => i.id == freeProduct);

      // ADD FREE PRODUCT
      if (total >= threshold && !freeItem) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: freeProduct, quantity: 1 })
        })
          .then(r => r.json())
          .then(() => load_cart());
        return;
      }

      // REMOVE FREE PRODUCT
      if (total < threshold && freeItem) {
        const removeBtn = document.querySelector(`.item-remove[data-line="${freeProduct}"]`);
        if (removeBtn) removeItem(removeBtn.dataset.line);
      }
    });
}

// =============================================================
// BUY X GET Y (First bundle)
// =============================================================
let bxgyLock = false;
let bxgySuppressUntil = 0;

async function handleBuyXGetY() {
  // prevent re-entry storms (rerender-triggered loops)
  if (Date.now() < bxgySuppressUntil) return;
  if (bxgyLock) return;
  bxgyLock = true;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const cartEl = document.querySelector("#cart");
  if (!cartEl) {
    bxgyLock = false;
    return;
  }

  const buyIds = (cartEl.dataset.buyId || "")
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => id > 0);

  const freeId = Number(cartEl.dataset.freeId || 0);

  if (!buyIds.length || !freeId) {
    bxgyLock = false;
    return;
  }

  const isAutoBxgy = (item) => item.properties && item.properties._bxgy === "true";

  const getCart = () => fetch("/cart.js").then((r) => r.json());

  const changeLine = (key, quantity, properties) =>
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(
        properties === undefined
          ? { id: key, quantity }
          : { id: key, quantity, properties }
      ),
    });

  const addLine = (variantId, quantity, properties) =>
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity, properties }),
    });

  try {
    await sleep(150);

    let mutated = false;

    let cart = await getCart();

    // 1) COUNT BUY ITEMS
    let totalBuyQty = 0;
    for (const item of cart.items) {
      if (buyIds.includes(item.variant_id)) totalBuyQty += item.quantity;
    }
    const desiredAutoQty = totalBuyQty;

    // 2) Collect brush lines in cart order
    const brushLines = cart.items
      .filter((it) => it.variant_id === freeId)
      .map((it) => ({
        key: it.key,
        quantity: it.quantity,
        isAuto: isAutoBxgy(it),
      }));

    const autoQty = brushLines.filter(l => l.isAuto).reduce((s, l) => s + l.quantity, 0);
    const totalBrushQty = brushLines.reduce((s, l) => s + l.quantity, 0);

    // 3) If buy = 0, remove ONLY auto brushes
    if (desiredAutoQty === 0) {
      if (autoQty > 0) {
        for (const l of brushLines.filter(l => l.isAuto)) {
          await changeLine(l.key, 0);
          mutated = true;
        }
      }

      if (mutated) {
        bxgySuppressUntil = Date.now() + 800;
        load_cart();
      }
      return;
    }

    // 4) Ensure we have at least desiredAutoQty brush quantity total.
    // Only add when missing in TOTAL brush qty.
    if (totalBrushQty < desiredAutoQty) {
      const qtyToAdd = desiredAutoQty - totalBrushQty;
      await addLine(freeId, qtyToAdd, { _bxgy: "true" });
      mutated = true;

      bxgySuppressUntil = Date.now() + 800;
      load_cart();
      return;
    }

    // 5) Normalize tags so EXACTLY desiredAutoQty brush quantity is AUTO.
    // We do it in TWO passes to make it idempotent and avoid flip-flopping.

    // PASS A: If we have TOO MUCH auto, DEMOTE the excess auto qty to manual (paid)
    if (autoQty > desiredAutoQty) {
      let excess = autoQty - desiredAutoQty;

      // demote from the end of cart order first
      const autoLinesReverse = [...brushLines].filter(l => l.isAuto).reverse();

      for (const l of autoLinesReverse) {
        if (excess <= 0) break;

        if (l.quantity <= excess) {
          // whole line becomes manual
          await changeLine(l.key, l.quantity, {}); // clear props
          mutated = true;
          excess -= l.quantity;
        } else {
          // split: keep some auto, move the rest to manual
          const manualQty = excess;
          const remainAutoQty = l.quantity - manualQty;

          await changeLine(l.key, remainAutoQty, { _bxgy: "true" });
          await addLine(freeId, manualQty, {}); // manual split
          mutated = true;

          excess = 0;
        }
      }

      // refresh after structural changes (splits)
      cart = await getCart();
    }

    // Rebuild brushLines after possible splits/demotions
    const brushLines2 = cart.items
      .filter((it) => it.variant_id === freeId)
      .map((it) => ({
        key: it.key,
        quantity: it.quantity,
        isAuto: isAutoBxgy(it),
      }));

    const autoQty2 = brushLines2.filter(l => l.isAuto).reduce((s, l) => s + l.quantity, 0);

    // PASS B: If we have TOO LITTLE auto, PROMOTE earliest manual qty to auto (so Shopify tends to discount it)
    if (autoQty2 < desiredAutoQty) {
      let need = desiredAutoQty - autoQty2;

      const manualLines = brushLines2.filter(l => !l.isAuto);

      for (const l of manualLines) {
        if (need <= 0) break;

        if (l.quantity <= need) {
          await changeLine(l.key, l.quantity, { _bxgy: "true" });
          mutated = true;
          need -= l.quantity;
        } else {
          // split manual line: part auto, remainder manual
          const autoPart = need;
          const manualRemainder = l.quantity - autoPart;

          await changeLine(l.key, autoPart, { _bxgy: "true" });
          await addLine(freeId, manualRemainder, {}); // keep remainder manual
          mutated = true;

          need = 0;
        }
      }
    }

    // Only rerender if we actually changed cart
    if (mutated) {
      bxgySuppressUntil = Date.now() + 800; // stop rerender-trigger loops
      load_cart();
    }
  } catch (e) {
    // console.error(e);
  } finally {
    bxgyLock = false;
  }
}



// =============================================================
// BUY X GET Y (Second bundle)
// =============================================================
let bxgyLock_second = false;
let bxgySuppressUntil_second = 0;

async function handleBuyXGetY_Second() {
  if (Date.now() < bxgySuppressUntil_second) return;
  if (bxgyLock_second) return;
  bxgyLock_second = true;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  try {
    await sleep(150);

    const cartEl = document.querySelector("#cart");
    if (!cartEl) return;

    const buyIds = (cartEl.dataset.buyId2 || "")
      .split(",")
      .map((id) => Number(id.trim()))
      .filter((id) => id > 0);

    const freeId = Number(cartEl.dataset.freeId2 || 0);

    if (!buyIds.length || !freeId) return;

    // Unique tag for bundle #2
    const TAG_KEY = "_bxgy2";
    const TAG_VALUE = "true";

    const isAuto = (item) => item.properties && item.properties[TAG_KEY] === TAG_VALUE;

    const getCart = () => fetch("/cart.js").then((r) => r.json());

    const changeLine = (key, quantity, properties) =>
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          properties === undefined
            ? { id: key, quantity }
            : { id: key, quantity, properties }
        ),
      });

    const addLine = (variantId, quantity, properties) =>
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity, properties }),
      });

    let mutated = false;

    // --- Load cart
    let cart = await getCart();

    // 1) COUNT BUY ITEMS
    let totalBuyQty = 0;
    for (const item of cart.items) {
      if (buyIds.includes(item.variant_id)) totalBuyQty += item.quantity;
    }

    const desiredAutoQty = totalBuyQty;

    // 2) Collect all Y (freeId) lines in cart order
    const yLines = cart.items
      .filter((it) => it.variant_id === freeId)
      .map((it) => ({
        key: it.key,
        quantity: it.quantity,
        isAuto: isAuto(it),
      }));

    const autoQty = yLines.filter((l) => l.isAuto).reduce((s, l) => s + l.quantity, 0);
    const totalYQty = yLines.reduce((s, l) => s + l.quantity, 0);

    // 3) If buy qty = 0 => remove ONLY auto-tagged lines
    if (desiredAutoQty === 0) {
      if (autoQty > 0) {
        for (const l of yLines.filter((l) => l.isAuto)) {
          await changeLine(l.key, 0);
          mutated = true;
        }
      }

      if (mutated) {
        bxgySuppressUntil_second = Date.now() + 800;
        load_cart();
      }
      return;
    }

    // 4) Ensure enough total Y exists (auto+manual) to satisfy entitlement
    if (totalYQty < desiredAutoQty) {
      const qtyToAdd = desiredAutoQty - totalYQty;
      await addLine(freeId, qtyToAdd, { [TAG_KEY]: TAG_VALUE });
      mutated = true;

      bxgySuppressUntil_second = Date.now() + 800;
      load_cart();
      return;
    }

    // 5) Normalize tags so EXACTLY desiredAutoQty of Y quantity is auto-tagged

    // PASS A: If too much auto, DEMOTE the excess auto qty to manual (clear properties)
    if (autoQty > desiredAutoQty) {
      let excess = autoQty - desiredAutoQty;

      // demote from the end of cart order first
      const autoLinesReverse = [...yLines].filter((l) => l.isAuto).reverse();

      for (const l of autoLinesReverse) {
        if (excess <= 0) break;

        if (l.quantity <= excess) {
          // whole line becomes manual
          await changeLine(l.key, l.quantity, {});
          mutated = true;
          excess -= l.quantity;
        } else {
          // split: keep some auto, move excess to manual
          const manualQty = excess;
          const remainAutoQty = l.quantity - manualQty;

          await changeLine(l.key, remainAutoQty, { [TAG_KEY]: TAG_VALUE });
          await addLine(freeId, manualQty, {}); // manual split
          mutated = true;

          excess = 0;
        }
      }

      // refresh after splits (new keys created)
      cart = await getCart();
    }

    // Rebuild yLines after possible changes
    const yLines2 = cart.items
      .filter((it) => it.variant_id === freeId)
      .map((it) => ({
        key: it.key,
        quantity: it.quantity,
        isAuto: isAuto(it),
      }));

    const autoQty2 = yLines2.filter((l) => l.isAuto).reduce((s, l) => s + l.quantity, 0);

    // PASS B: If not enough auto, PROMOTE earliest manual qty to auto
    if (autoQty2 < desiredAutoQty) {
      let need = desiredAutoQty - autoQty2;

      const manualLines = yLines2.filter((l) => !l.isAuto);

      for (const l of manualLines) {
        if (need <= 0) break;

        if (l.quantity <= need) {
          await changeLine(l.key, l.quantity, { [TAG_KEY]: TAG_VALUE });
          mutated = true;
          need -= l.quantity;
        } else {
          // split manual line: part auto, remainder manual
          const autoPart = need;
          const manualRemainder = l.quantity - autoPart;

          await changeLine(l.key, autoPart, { [TAG_KEY]: TAG_VALUE });
          await addLine(freeId, manualRemainder, {}); // keep remainder manual
          mutated = true;

          need = 0;
        }
      }
    }

    // Only rerender if we actually changed cart
    if (mutated) {
      bxgySuppressUntil_second = Date.now() + 800;
      load_cart();
    }
  } catch (e) {
    // console.error(e);
  } finally {
    bxgyLock_second = false;
  }
}

function cartDrawerUpdate() {
    var url = window.location.href;
    fetch(url)
    .then(response => response.text())
    .then(html => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      if (doc.querySelector('.section-cart') != null) {
      var mainSectionContent = doc.querySelector('.section-cart').innerHTML;
      document.querySelector('.section-cart').innerHTML = mainSectionContent;
      cartVariant();
      }

    })
    .catch(error => {
      console.error('Error fetching collection main section:', error);
    });
  }

// ------------------ REMOVE ITEM ------------------
function removeItem(data_line) {
  const data = { line: data_line, quantity: 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then(() => load_cart())
    .catch((error) => console.error('Error:', error));
}

// ------------------ UPDATE ITEM ------------------
function updateItem(data_line, data_qty) {
  const data = { line: data_line, quantity: data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then(() => {
      if (document.location.href.indexOf('/cart') > -1) {
        load_cart();
      } else {
        load_cart();
        setTimeout(() => document.querySelector('body').classList.add('open-drawer'), 500);
      }
    })
    .catch((error) => console.error('Error:', error));
}

// ------------------ CART VARIANT FUNCTIONS ------------------
function cartVariant() {
  // Plus
  document.querySelectorAll('.ci_plus a').forEach((plus) => {
    plus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      const input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      input.value = parseInt(input.value) + 1;
      const new_line = this.getAttribute('data-line-item');
      const new_qty = input.value;
      updateItem(new_line, new_qty);
    });
  });

  // Minus
  document.querySelectorAll('.ci_minus a').forEach((minus) => {
    minus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      const input = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      const currentQty = parseInt(input.value);
      const minQty = parseInt(input.getAttribute('min')) || 1;
      if (currentQty > minQty) {
        input.value = currentQty - 1;
        const newLine = this.getAttribute('data-line-item');
        const newQty = input.value;
        updateItem(newLine, newQty);
      }
    });
  });

  document.querySelectorAll('.cd_variant').forEach((cdVariantAdd) => {
    cdVariantAdd.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const variantCls = cdVariantAdd.closest('.cd_variant_cls');
      const variantList = variantCls.querySelector('.cd__variant_list');

      variantCls.classList.remove('active');
      if (variantList) variantList.style.maxHeight = "0px";

      const cart_error = cdVariantAdd.closest('.cartitems').querySelector('.cierror');
      const currentid = cdVariantAdd.closest('.cartitems').querySelector('.item-remove').getAttribute('data-line');
      const changevar_id = cdVariantAdd.getAttribute('data-id');
      const item_current_qty = cdVariantAdd.closest('.cartitems').querySelector('.cart_qty').value;

      const formData = { items: [{ id: changevar_id, quantity: item_current_qty }] };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
        .then(() => setTimeout(() => updateItem(currentid, 0), 500))
        .catch((error) => {
          console.error('error', error);
          if (cart_error) {
            cart_error.textContent = 'Error';
            setTimeout(() => (cart_error.textContent = ''), 2000);
          }
        });
    });
  });

  if (document.querySelectorAll('.drawer-btm-wrap').length) {
    document.querySelectorAll('.drawer-btm-wrap').forEach(drawerWrap => {
      let accoHeads = drawerWrap.querySelectorAll('.cart-acco-head');
      let accoWrapper = drawerWrap.querySelector('.cart-acco-wrapper');
      let accoContents = drawerWrap.querySelectorAll('.cart-acco-cont');
      let drawerMiddle = document.querySelector('.drawer-middle'); // global scroll area
      let closeBtn = drawerWrap.querySelector('.cart-acc-close a');

      if (!accoWrapper || !accoHeads.length) return;

      // ✅ Set default height (on load) — same logic as click
      let activeCont = drawerWrap.querySelector('.cart-acco-cont.active-content');
      if (activeCont) {
        let ul = activeCont.querySelector('ul');
        let contentHeight = ul ? ul.offsetHeight : 0;

        let contentMaxHeight =
          document.querySelector('.drawer-middle').offsetHeight -
          (document.querySelector('.center-drawer-header').offsetHeight +
          document.querySelector('.cart_slider_wrapper').offsetHeight +
          drawerWrap.querySelector('.cart-mbottom').offsetHeight);

        let finalHeight = Math.max(contentMaxHeight, contentHeight);
        accoWrapper.style.maxHeight = `${finalHeight}px`;
      } else {
        accoWrapper.style.maxHeight = '0';
      }

      // ✅ Accordion click logic
      accoHeads.forEach(head => {
        head.addEventListener('click', e => {
          e.preventDefault();

          let val = head.dataset.val;
          let content = drawerWrap.querySelector(`.cart-acco-cont[data-val="${val}"]`);
          let accoItem = head.closest('.cart-acco');
          let isOpen = accoItem.classList.contains('active');

          // Reset all
          drawerWrap.querySelectorAll('.cart-acco').forEach(a => a.classList.remove('active'));
          accoContents.forEach(c => c.classList.remove('active-content'));

          if (!isOpen) {
            accoItem.classList.add('active');
            content.classList.add('active-content');

            // Calculate height same way
            let contentMaxHeight =
              document.querySelector('.drawer-middle').offsetHeight -
              (document.querySelector('.center-drawer-header').offsetHeight +
              document.querySelector('.cart_slider_wrapper').offsetHeight +
              drawerWrap.querySelector('.cart-mbottom').offsetHeight);

            let ul = content.querySelector('ul');
            let contentHeight = ul ? ul.offsetHeight : 0;

            let finalHeight = Math.max(contentMaxHeight, contentHeight);
            accoWrapper.style.maxHeight = `${finalHeight}px`;

            // ✅ Add open-cart-acco only on mobile
            if (window.innerWidth <= 768) {
              accoWrapper.classList.add('open-cart-acco');
            }

            // Smooth scroll to bottom
            if (drawerMiddle) {
              drawerMiddle.scrollTo({
                top: drawerMiddle.scrollHeight,
                behavior: 'smooth'
              });
            }
          } else {
            accoWrapper.style.maxHeight = '0';
            accoWrapper.classList.remove('open-cart-acco');
          }
        });
      });

      // ✅ Close button logic
      if (closeBtn) {
        closeBtn.addEventListener('click', e => {
          e.preventDefault();

          drawerWrap.querySelectorAll('.cart-acco').forEach(a => a.classList.remove('active'));
          accoContents.forEach(c => c.classList.remove('active-content'));
          accoWrapper.style.maxHeight = '0';
          accoWrapper.classList.remove('open-cart-acco');
        });
      }
    });
  }




  // Variant open/close toggle with scroll height effect on .cd__variant_list
  const cdVariantBox = document.querySelectorAll('.cd_variant_cls');
  cdVariantBox.forEach((variantBox) => {
    const btn = variantBox.querySelector('.cd_variantbtn');
    const variantList = variantBox.querySelector('.cd__variant_list');

    if (btn && variantList) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        cdVariantBox.forEach((box) => {
          const innerList = box.querySelector('.cd__variant_list');
          if (box !== variantBox) {
            box.classList.remove('active');
            if (innerList) innerList.style.maxHeight = "0px";
          }
        });

        // Toggle current
        const isActive = variantBox.classList.toggle('active');
        if (isActive) {
          variantList.style.maxHeight = variantList.scrollHeight + "px";
        } else {
          variantList.style.maxHeight = "0px";
        }
      });
    }
  });

}

document.addEventListener('click', function (event) {
  if (event.target.closest('.quick-add-to-cart')) {
    const addToCartBtn = event.target.closest('.quick-add-to-cart');
    const line = addToCartBtn.getAttribute('data-id');
    if (!line) return;

    const title = addToCartBtn.getAttribute('data-pro-title') || '';
    const imgSrc = addToCartBtn.getAttribute('data-img-src') || '';

    // Elements for popup
    const cartPopup = document.getElementById('cart-popup');
    const popupTitle = document.getElementById('cart-popup-title');
    const popupImage = document.getElementById('cart-popup-image');
    const popupClose = document.querySelector('.cart-popup-close');

    let popupTimer;

    const data = { items: [{ id: line, quantity: 1 }] };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then(() => {
        // If user is on the cart page, refresh it
        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
          return;
        }

        // Update cart drawer or mini-cart
        if (typeof load_cart === 'function') load_cart();

        // Show cart popup
        popupTitle.textContent = title;
        popupImage.src = imgSrc;

        cartPopup.classList.remove('hidden');
        cartPopup.classList.add('visible');

        clearTimeout(popupTimer);
        popupTimer = setTimeout(() => {
          cartPopup.classList.remove('visible');
          setTimeout(() => cartPopup.classList.add('hidden'), 300);
        }, 3000);
      })
      .catch((error) => console.error('Error:', error));

    // Allow manual close (attach once)
    if (popupClose && !popupClose.hasListener) {
      popupClose.addEventListener('click', function () {
        clearTimeout(popupTimer);
        cartPopup.classList.remove('visible');
        setTimeout(() => cartPopup.classList.add('hidden'), 300);
      });
      popupClose.hasListener = true;
    }
  }
});




const drawer = document.querySelector('.cart-sidebar');

drawer.addEventListener('wheel', (e) => {
  e.stopPropagation();
}, { passive: false });

drawer.addEventListener('touchstart', (e) => {
  e.stopPropagation();
}, { passive: false });

drawer.addEventListener('touchmove', (e) => {
  e.stopPropagation();
}, { passive: false });

if (window.innerWidth < 767) {
 const mobileinner = document.querySelector('.cart-sidebar #cart');
  if (mobileinner){
    mobileinner.addEventListener('wheel', (e) => {
      e.stopPropagation();
    }, { passive: false });

    mobileinner.addEventListener('touchstart', (e) => {
      e.stopPropagation();
    }, { passive: false });

    mobileinner.addEventListener('touchmove', (e) => {
      e.stopPropagation();
    }, { passive: false });
 }

}



// ------------------ SWIPER INITS ------------------
function initSearchRowSwipers() {
  setTimeout(() => {
    document.querySelectorAll('.emtycart_slider').forEach((searchRow) => {      
      if (searchRow.classList.contains('swiper-initialized')) return;
      new Swiper(searchRow, { 
        slidesPerView: 2.1, 
        spaceBetween: 1, 
        loop: false, 
        freeMode: true, 
        watchOverflow: true 
      });
    });
  },2000);
}


function initCartmbUpsell() {
  document.querySelectorAll('.cart_upsell_wrap').forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;
    new Swiper(slider, {
      slidesPerView: 2.3, spaceBetween: 1, loop: false, freeMode: true, watchOverflow: true,preventClicks: false,preventClicksPropagation: false,
      mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: 1, thresholdDelta: 1, thresholdTime: 200 }
    });
  });
}

function initCartSliders() {
  document.querySelectorAll('.cart-slider').forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;
    new Swiper(slider, {
      slidesPerView: 3.3, spaceBetween: 1, loop: false, watchOverflow: true, freeMode: true,
      mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: 1, thresholdDelta: 1, thresholdTime: 200 },
      navigation: { nextEl: '.cdh-buttons .swiper-button-next', prevEl: '.cdh-buttons .swiper-button-prev' },
    });
  });
}

// ------------------ INIT ON DOM ------------------
document.addEventListener('DOMContentLoaded', () => {
  initCartSliders();
  initCartmbUpsell();
  if (window.innerWidth < 767) {
    initSearchRowSwipers();
  }
});
if (window.innerWidth < 767) {
initSearchRowSwipers();
}
// ------------------ RESIZE HANDLER ------------------
window.resizeTimeout = window.resizeTimeout || null;

window.addEventListener('resize', () => {
  clearTimeout(window.resizeTimeout);
  window.resizeTimeout = setTimeout(() => {
    initCartmbUpsell();
    if (window.innerWidth > 767) {
      initCartSliders();
    } else {
      initSearchRowSwipers();
    }
  }, 250);
});


// ------------------ LOAD INITIAL CART ------------------
load_cart();